import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import Extent from "../Core/Geographic/Extent";
var InfoLayer = /*#__PURE__*/function () {
  function InfoLayer(layer) {
    _classCallCheck(this, InfoLayer);
    this.layer = layer;
  }
  // eslint-disable-next-line
  _createClass(InfoLayer, [{
    key: "clear",
    value: function clear() {}
    // eslint-disable-next-line
  }, {
    key: "update",
    value: function update() {}
  }]);
  return InfoLayer;
}();
/**
 * InfoTiledGeometryLayer that provides some states layer informations. These
 * informations are displayed tiles, displayed {@link ColorLayer} and {@link
 * ElevationLayer} and extent of displayed tiles.
 *
 * @class InfoTiledGeometryLayer
 *
 * @property {object} displayed
 * @property {Layer[]} displayed.layers - Displayed {@link ColorLayer} and {@link ElevationLayer}.
 * @property {Extent} displayed.extent - {@link Extent} of displayed tiles.
 * @property {Set} displayed.tiles - Set of displayed tiles.
 */
export { InfoLayer as default };
export var InfoTiledGeometryLayer = /*#__PURE__*/function (_InfoLayer) {
  _inherits(InfoTiledGeometryLayer, _InfoLayer);
  var _super = _createSuper(InfoTiledGeometryLayer);
  function InfoTiledGeometryLayer(tiledGeometryLayer) {
    var _this;
    _classCallCheck(this, InfoTiledGeometryLayer);
    _this = _super.call(this, tiledGeometryLayer);
    _this.displayed = {
      tiles: new Set()
    };
    Object.defineProperty(_this.displayed, 'layers', {
      get: function get() {
        var layers = [];
        _this.displayed.tiles.forEach(function (tile) {
          var m = tile.material;
          layers = _toConsumableArray(new Set([].concat(_toConsumableArray(layers), _toConsumableArray(m.colorLayerIds.filter(function (id) {
            return m.getLayer(id);
          })), _toConsumableArray(m.elevationLayerIds))));
        });
        return _this.layer.attachedLayers.filter(function (l) {
          return layers.includes(l.id);
        });
      }
    });
    Object.defineProperty(_this.displayed, 'extent', {
      get: function get() {
        var extent = new Extent(_this.layer.extent.crs, Infinity, -Infinity, Infinity, -Infinity);
        extent.min = +Infinity;
        extent.max = -Infinity;
        _this.displayed.tiles.forEach(function (tile) {
          extent.union(tile.extent);
          extent.min = Math.min(tile.obb.z.min, extent.min);
          extent.max = Math.max(tile.obb.z.max, extent.max);
        });
        return extent;
      }
    });
    return _this;
  }
  _createClass(InfoTiledGeometryLayer, [{
    key: "clear",
    value: function clear() {
      this.displayed.tiles.clear();
    }
  }, {
    key: "update",
    value: function update(tile) {
      if (tile.material.visible) {
        this.displayed.tiles.add(tile);
      } else {
        this.displayed.tiles["delete"](tile);
      }
    }
  }]);
  return InfoTiledGeometryLayer;
}(InfoLayer);